import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import './App.css'
import Routes from "./routes";
import { history } from "./helpers";
import { userActions } from "./store/actions";
import { MuiAlert } from "./components/Alert";
import Tracking from "./services/tracking.service";
import { userAndTokenExist } from "./services/storage.service";
import { storeUTMAndSource } from "./services/sourceandutm.tracking.service";

export default function () {
    const dispatch = useDispatch();
    

    useEffect(() => {
        Tracking.initializeTracking();
        storeUTMAndSource();
    }, [])

    useEffect(() => {

        /**
         * Below function executes everytime the user opens a new page 
         */
        if (userAndTokenExist())
            dispatch(userActions.validateToken());

    }, [history.location.pathname]);

    return (
        <div className="App">
            <MuiAlert />
            <Routes />
        </div>
    );
}